(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class QuantityTotalPrice extends HTMLElement {
    connectedCallback() {
      this.productForm = this.closest('product-form-component');
      this.quantityInput = this.productForm?.querySelector('input[name="quantity"]');
      this.totalValue = this.querySelector('[data-total-price-value]');
      this.unitPrice = Number(this.dataset.unitPrice || 0);
      this.currency = this.dataset.currency || 'EUR';
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: this.currency,
      });

      this.updateTotal();

      this.handleInteraction = () => {
        requestAnimationFrame(() => this.updateTotal());
      };

      this.productForm?.addEventListener('click', this.handleInteraction);
      this.productForm?.addEventListener('input', this.handleInteraction);
      this.productForm?.addEventListener('change', this.handleInteraction);
    }

    disconnectedCallback() {
      this.productForm?.removeEventListener('click', this.handleInteraction);
      this.productForm?.removeEventListener('input', this.handleInteraction);
      this.productForm?.removeEventListener('change', this.handleInteraction);
    }

    updateTotal() {
      if (!this.totalValue) return;
      const quantity = Math.max(1, Number(this.quantityInput?.value) || 1);
      this.totalValue.textContent = this.formatter.format((this.unitPrice * quantity) / 100);
    }
  }

  if (!customElements.get('quantity-total-price')) {
    customElements.define('quantity-total-price', QuantityTotalPrice);
  }
  } catch(e) { console.error(e); }
})();

})();
